/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type { PlainHashMap } from '@modules/ui-types'

export function undefineEmptyStrings<T extends PlainHashMap>(value: T): T {
  const result = Array.isArray(value) ? [] : {}

  for (const [key, property] of Object.entries(value)) {
    if (property === '') {
      result[key] = undefined
    } else if (property !== null && typeof property === 'object') {
      result[key] = undefineEmptyStrings(property)
    } else {
      result[key] = property
    }
  }

  return result as T
}
